<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius frame-accounts heig-frame-equipment-group userTable">
            <b-row no-gutters>
                <b-col md="12" class="text-right mb-25">
                    <gofix-button @click="save" :disabled="!$checkRole($accessModule.password_management, 'create') && !$checkRole($accessModule.password_management, 'update')" :loading="loading" label="Save"></gofix-button>
                </b-col>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card title="Password Management" classContent="mt-4">
                        <b-row class="mb-25 align-items-center">
                            <b-col md="2">
                                <b-form-checkbox v-model="config.is_allow_expired_months" class="ml-16">
                                    <span class="ml-2">Password Expires Every</span>
                                </b-form-checkbox>
                            </b-col>
                            <b-col md="3">
                                <gofix-form-input-number
                                    label="Expires Every"
                                    :disabled="!config.is_allow_expired_months"
                                    v-model="config.expired_months"
                                    :required="config.is_allow_expired_months"
                                    :desc="`[months]`">
                                </gofix-form-input-number>
                            </b-col>
                            <b-col md="2">
                                <b-form-checkbox v-model="config.is_allow_digit" class="ml-16">
                                    <span class="ml-2">Contains Digits</span>
                                </b-form-checkbox>
                            </b-col>
                            <b-col md="2">
                                <b-form-checkbox v-model="config.is_allow_spec_characters" class="ml-16">
                                    <span class="ml-2">Contains Special Characters</span>
                                </b-form-checkbox>
                            </b-col>
                            <b-col md="2">
                                <b-form-checkbox v-model="config.is_allow_cap_small_letter" class="ml-16">
                                    <span class="ml-2">Must Contain Capital and Small Letters</span>
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                        <b-row class="mb-25 align-items-center">
                            <b-col md="2">
                                <gofix-form-input-number
                                    label="Minimum Number Of Characters"
                                    v-model="config.minimum_characters"
                                    :integerLimit="3"
                                    :desc="`Number 1 to 128`">
                                </gofix-form-input-number>
                            </b-col>
                            <b-col md="3">
                                <gofix-form-input-number
                                    label="Maximum Number Of Characters"
                                    v-model="config.maximum_characters"
                                    :integerLimit="3"
                                    :desc="`Number 1 to 128`">
                                </gofix-form-input-number>
                            </b-col>
                            <b-col md="3">
                                <gofix-form-input-number
                                    :include-thousands-separator="false" 
                                    :allowDecimal="false" 
                                    label="Max number of failed log-in attempt"
                                    v-model="config.max_num_retries">
                                </gofix-form-input-number>
                            </b-col>
                            <b-col md="3">
                                <gofix-form-input-number
                                    :include-thousands-separator="false" 
                                    :allowDecimal="false" 
                                    label="Minimum number of previous password remembered"
                                    v-model="config.min_num_prev_pwd_remember">
                                </gofix-form-input-number>
                            </b-col>
                        </b-row>
                    </gofix-card>
                    <gofix-card title="Session Timeout" classContent="mt-4">
                        <b-row class="mb-25 align-items-center">
                            <b-col md="3">
                                <gofix-form-input-number
                                    :include-thousands-separator="false" 
                                    :allowDecimal="false" 
                                    label="Web Browser"
                                    v-model="config.inactivity_timeout_web"
                                    :desc="`[minutes]`">
                                </gofix-form-input-number>
                            </b-col>
                            <b-col md="3">
                                <gofix-form-input-number
                                    :include-thousands-separator="false" 
                                    :allowDecimal="false" 
                                    label="Mobile App"
                                    v-model="config.inactivity_timeout_mobile"
                                    :desc="`[minutes]`">
                                </gofix-form-input-number>
                            </b-col>
                        </b-row>
                    </gofix-card>
                    <gofix-card title="Platform Settings" classContent="mt-4">
                        <b-row class="mb-25 align-items-center">
                            <b-col md="3">
                                <gofix-text-field label="Require MS OTP Authentication" oneline>
                                    <b-form-checkbox :value="true" v-model="config.mfa_required" :unchecked-value="false" switch>
                                    </b-form-checkbox>
                                </gofix-text-field>
                            </b-col>
                        </b-row>
                    </gofix-card>
                    <gofix-card title="Global Settings" classContent="mt-4">
                        <b-row class="mb-25 align-items-center">
                            <b-col md="5">
                                <gofix-form-input-number
                                    label="Set duplicate dorj same block and lift number in a range of “X“ days."
                                    v-model="config.dorj_duplicate_days"
                                    :integerLimit="3"
                                    :desc="`[days]`">
                                </gofix-form-input-number>
                            </b-col>
                        </b-row>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'users',
        data() {
            return {
                timer: null,
                loading: false,
                config: {
                    is_allow_expired_months: false,
                    expired_months: null,
                    minimum_characters: null,
                    maximum_characters: null,
                    is_allow_cap_small_letter: false,
                    is_allow_digit: false,
                    is_allow_spec_characters: false,
                    max_num_retries: null,
                    min_num_prev_pwd_remember:null,
                    inactivity_timeout_web:null,
                    inactivity_timeout_mobile:null,
                    mfa_required:false,
                    dorj_duplicate_days:7
                }
            }
        },
        created() {
            this.getData();
        },
        methods: {
            getData() {
                this.$store.dispatch(`v2UserController/getPasswordManagement`, {})
                .then(response => {
                    this.config = Object.assign(this.config, response)
                })
                .catch(error => {
                    console.log(error);
                })
            },
            save() {
                if(this.config.is_allow_expired_months && !this.config.expired_months) {
                    return this.$alertNotification("Expires every is required", "danger");
                }

                if(!this.config.minimum_characters) {
                    return this.$alertNotification("Minimum number of characters is required", "danger");
                }

                if(Number(this.config.minimum_characters) > 128) {
                    return this.$alertNotification("Minimum number of characters must be less than 128 characters", "danger");
                }

                if(!this.config.maximum_characters) {
                    return this.$alertNotification("Maximum number of characters is required", "danger");
                }

                if(Number(this.config.maximum_characters) > 128) {
                    return this.$alertNotification("Maximum number of characters must be less than 128 characters", "danger");
                }

                if(Number(this.config.maximum_characters) < Number(this.config.minimum_characters)) {
                    return this.$alertNotification("Maximum number of characters must be greater than the minimum number of characters", "danger");
                }

                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    this.$store.dispatch(`v2UserController/updatePasswordManagement`, this.config)
                    .then(response => {
                        this.config = Object.assign(this.config, response)
                        this.$alertNotification(this.$notificationV2('editing', 'password_management'));
                    })
                    .catch(error => {
                        console.log(error);
                    })
                }, 300);
            }
        }
    }
</script>
